// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.store/css-loader@5.2.7/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".seachTiele[data-v-6ce5c7ce] {\n  line-height: 35px;\n}\n.fr[data-v-6ce5c7ce] {\n  float: right;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
